export const CURRENT_VERSION = "3.7.0";
